import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

export const CSBTypeOptions: DropdownOptionType[] = [
  { value: 'csb4', display: 'CSB4' },
  { value: 'csb5', display: 'CSB5' },
];

export const TermsOfInvoiceOptions: DropdownOptionType[] = [
  { value: 'ddu', display: 'DDU' },
  { value: 'ddp', display: 'DDP' },
];

export const TaxPaymentOptions: DropdownOptionType[] = [
  { value: 'NA', display: 'N/A' },
  { value: 'Against Bond', display: 'Against Bond' },
  { value: 'Under taking', display: 'Under Taking' },
  { value: 'IGST', display: 'IGST' },
];

export const IsHavingBatteryOptions: DropdownOptionType[] = [
  { value: 'yes', display: 'Yes' },
  { value: 'no', display: 'No' },
];

export const batteryTypeOptions: DropdownOptionType[] = [
  { value: 'Lithium Ion Alloy', display: 'Lithium Ion Alloy' },
  { value: 'Lithium Ion Polymer', display: 'Lithium Ion Polymer' },
];
export const batteryPackingOptions: DropdownOptionType[] = [
  { value: 'Inside Equipment', display: 'Inside Equipment' },
  { value: 'Packaged with Equipment', display: 'Packaged with Equipment' },
  { value: 'Battery Only', display: 'Battery Only' },
];

export const PickupAddressOptions: DropdownOptionType[] = [{ value: '39898', display: 'Testing Pickup Address' }];

export const thinkLogisticsInformationValidation = Yup.object().shape({
  type: Yup.string().trim().required('Type is required'),
  accountNo: Yup.string().trim().required('Account is required'),
  csb_type: Yup.string().trim().required('CSB Type is required'),
  terms_of_invoice: Yup.string().trim().required('Terms of Invoice is required'),
  tax_payment_option: Yup.string().trim().required('Tax Payment Option is required'),
  is_having_battery: Yup.string().trim().required('Is Having Battery is required'),
  pickup_address_id: Yup.string().trim().required('Pickup Address ID is required'),
});

export interface ThinkLogisticsInformationSchema {
  type: string;
  csp: string;
  accountNo: string;
  pickup_address_id: string;
  csb_type: string;
  terms_of_invoice: string;
  tax_payment_option: string;
  is_having_battery: string;
  awbShowToUser: boolean;
}

export const onForward = async ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
  setLoading,
}: {
  values: ThinkLogisticsInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  try {
    setLoading(true);

    const body: any = { ...JSON.parse(JSON.stringify(values)) };
    body.csp = 'ithinklogistics';

    for (const key in body) {
      if (body[key]) {
        if (key === 'accountNo') {
          if (Array.isArray(body[key])) {
            body[key] = body[key][0]?.value?.split('-')?.[0] || '';
          } else if (typeof body[key] === 'object' && body[key]?.value) {
            body[key] = body[key].value.split('-')?.[0] || '';
          } else if (typeof body[key] === 'string') {
            body[key] = body[key].split('-')?.[0];
          }
        }
      }
    }

    const response: any = await dispatch(
      postFedExDetails({
        shipmentNumber: `${shipmentNumber}`,
        body,
        date: null,
        nextFunc,
      }),
    );

    // call nextFunc only when success
    if (response.meta.requestStatus === 'fulfilled') {
      nextFunc();
    }
  } catch (error) {
    console.error('Error in onForward:', error);
  } finally {
    setLoading(false);
  }
};
